export default "__VITE_ASSET__3a5633db__"